<template>
  <div>
    <div ref="googleTranslateElement" id="google_translate_element"></div>
  </div>
</template>

<script>
export default {
  name: 'GoogleTranslate',
  mounted() {
    let app = this
    app.googleTranslate();
  },
  methods: {
    googleTranslate () {
      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
            {
              pageLanguage: 'en',
              includedLanguages: 'en,es,fr,de,it,pt,la',
              layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
              autoDisplay: false,
            },
            this.$refs.googleTranslateElement
        );
      };

      const script = document.createElement('script');
      script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.head.appendChild(script);
    }
  }
}
</script>
<style scoped>
#google_translate_element {
  position: absolute;
  top: 10px; /* Adjust as needed */
  right: 10px;
  z-index: 10000;
}

</style>
